import { IServerResponse } from "app/interface";

export interface LocationState {
    locationList: Array<any> | null;
    saveLocationResponse: IServerResponse;
    deleteLocationResponse: IServerResponse
}

export const initialState: LocationState = {
    locationList: null,
    saveLocationResponse: null,
    deleteLocationResponse: null
}
